import React, { useContext, useState, useEffect } from 'react';


const AmazonContext = React.createContext();

export function useGlobalDataContext() {
    return useContext(AmazonContext);
}

export function AmazonContextProvider(props) {
    const [millValue, setMillValue] = useState(null);
    const [inventoryAtValue, setInventoryAtValue] = useState(null);
    const [shipmentReleaseDate, setShipmentReleaseDate] = useState();
    const [shipmentReleaseWeighht, setShipmentReleaseWeighht] = useState();
  const [shipmentInstruction, setShipmentInstruction] = useState();

    const [assetRows, setAssetRows] = useState([{asset_name:"computer",asset_id:"1",assigned_to:"invera"}])
    const [assetColumns, setAssetColumns] = useState([
        { field: 'asset_name', headerName: "Asset Name", sortable: false, width: 150 },
        { field: 'asset_id', headerName: "Asset Id", sortable: false, width: 100 },
       
        { field: 'assigned_to', headerName: "Assigned To", sortable: false, width: 100 },
    

    ]);

 

 
    useEffect(() => {


    }, []);
    const value = {
        millValue, setMillValue,
        inventoryAtValue, setInventoryAtValue,
        // TransferAsst, setTrasferAssets,
        shipmentReleaseDate, setShipmentReleaseDate,
        shipmentReleaseWeighht, setShipmentReleaseWeighht,
        shipmentInstruction, setShipmentInstruction,
        assetRows, setAssetRows,
        assetColumns, setAssetColumns,
       
       


    }

    return (
        <AmazonContext.Provider value={value}>
            {props.children}
        </AmazonContext.Provider>
    );
}
